module.exports = __webpack_public_path__ + "img/ProduktBG.27832576.png";